import { render, staticRenderFns } from "./Popup.html?vue&type=template&id=3e891295&external"
import script from "./Popup.ts?vue&type=script&lang=ts&external"
export * from "./Popup.ts?vue&type=script&lang=ts&external"
import style0 from "./Popup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports